(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aspirator-product-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.chReady) return;
    root.dataset.chReady = '1';
    var form = root.querySelector('.ch-form');
    if (!form) return;
    var fmt = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: root.dataset.currency || 'PLN' });
    var btn = form.querySelector('[data-atc]');
    var bar = root.querySelector('[data-bar]');
    var barTotal = root.querySelector('[data-bar-total]');
    var barBtn = root.querySelector('[data-bar-btn]');
    var thumbs = root.querySelectorAll('.ch-th');
    function money(c) { return fmt.format(c / 100); }
    function curVar() { return form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]'); }
    function show(th) {
      var img = root.querySelector('.ch-stage img');
      if (!img) return;
      img.src = th.dataset.src;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      thumbs.forEach(function (x) { x.removeAttribute('aria-current'); });
      th.setAttribute('aria-current', 'true');
    }
    function render() {
      var v = curVar();
      var price = parseInt(v.dataset.price, 10);
      var cmp = parseInt(v.dataset.compare, 10) || 0;
      var vn = root.querySelector('[data-vname]');
      if (vn) vn.textContent = v.dataset.name;
      root.querySelector('[data-price]').textContent = money(price);
      var pc = root.querySelector('[data-cmp]');
      pc.textContent = money(cmp);
      pc.hidden = !(cmp > price);
      var sel = 0;
      form.querySelectorAll('input[name="quantity"]').forEach(function (t) {
        var q = parseInt(t.value, 10);
        var d = parseInt(t.dataset.d, 10) || 0;
        var tot = Math.round(price * q * (100 - d) / 100);
        var full = price * q;
        var box = t.closest('.ch-tier');
        box.querySelector('[data-tot]').textContent = money(tot);
        var f = box.querySelector('[data-full]');
        if (f) { f.textContent = money(full); f.hidden = full <= tot; }
        box.querySelector('[data-unit]').textContent = money(tot / q) + ' / szt.';
        box.querySelector('[data-save]').textContent = full > tot ? 'Oszczędzasz ' + money(full - tot) : '';
        if (t.checked) sel = tot;
      });
      var out = v.disabled;
      btn.disabled = out;
      btn.textContent = out ? 'Wyprzedane' : 'Dodaj do koszyka · ' + money(sel);
      if (barTotal) barTotal.textContent = money(sel);
      if (barBtn) { barBtn.disabled = out; barBtn.textContent = out ? 'Wyprzedane' : 'Dodaj do koszyka'; }
    }
    thumbs.forEach(function (th) { th.addEventListener('click', function () { show(th); }); });
    form.addEventListener('change', function (e) {
      if (e.target.name === 'id') {
        var th = root.querySelector('.ch-th[data-media="' + e.target.dataset.media + '"]');
        if (th) show(th);
      }
      render();
    });
    render();
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(btn);
    }
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-ch]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
